import { Locale, Segment } from '@fixter/i18n';
import config from 'config';
import Cookies from 'js-cookie';
import { ActiveExperiments } from '$util/abTest/experiments';
import { useActiveExperiment } from '$util/abTest';
import { useAppContext } from '$util/AppContext';
import type { AppContextGlobal } from '$util/AppContextGlobal';
import { context } from '@/contexts/GlobalContext';

/**
 * This holds the state of feature flags that we use for TBD.
 *
 * Each flag will be manually added to this from config in order
 * to document it with what story it represents and what is the intention for it.
 */
export const features = {};

export const isFeatureSchedulePageOptionalCnDActive = (segment: Segment): boolean => {
  const local = segment === Segment.Fixter_FR ? Locale.FR_FR : Locale.EN_GB;
  return config.get<boolean>(`public.features.schedulePageOptionalCnD.${local}`);
};

export const isFeaturePriceMatchPromiseActive = (segment: Segment): boolean => {
  const local = segment === Segment.Fixter_FR ? Locale.FR_FR : Locale.EN_GB;
  return config.get<boolean>(`public.features.priceMatchPromise.${local}`);
};

export const isStripeInternationalActive = config.get<boolean>(`public.features.internationalStripeActive`);

export const isFeatureGlobalPromotionActive = (locale: Locale): boolean => {
  return config.get<boolean>(`public.features.globalCampaign.${locale}.display`);
};

export const getFeatureGlobalPromotionCampaignId = (locale: Locale): string => {
  return config.get<string>(`public.features.globalCampaign.${locale}.campaignId`);
};

/**
 * Kontiki: FR partner
 * Initial story: https://fixter.atlassian.net/browse/GRW-2476
 */
export const isKontikiTrackingActive = (local: Locale): boolean => {
  const partnerCookie = Cookies.get('fixterPartner');
  return partnerCookie === 'kontiki' && config.get<boolean>(`public.features.partners.kontiki.${local}`);
};

export const isFeatureContactUsFormActive = (local: Locale): boolean => {
  return config.get<boolean>(`public.features.contactUsForm.${local}`);
};

/**
 * @returns `true` ? new assets : Fixie
 *
 * @description
 * * flag NOT active: Fixie
 * * FR: new assets
 * * UK AB test variant B: Fixie
 * * otherwise: new assets
 *
 * @note used on App & Page Router so we can't read directly from `config`
 */
export const useIsBrandCampaignAbTest = (): boolean => {
  const { locale } = useAppContext<AppContextGlobal>();
  const isBrandFixieAbTestUK = useActiveExperiment(ActiveExperiments.BrandCampaignUK, 'B');
  const isFeatureBrandCampaignEnabled = context.get<boolean>('isFeatureBrandCampaignEnabled');
  if (!isFeatureBrandCampaignEnabled) return false;
  if (locale === Locale.FR_FR) return true;
  return !isBrandFixieAbTestUK;
};
